<template>
    <div class="page-home">
        <div class="jumbo-wrapper home">
            <div class="jumbo-main home">
                <div class="jumbo-content">
                    <h2 class="t42">SUBSTANTIAL REVENUE. LASTING IMPACT.</h2>
                    <p class="t20">CREATE LASTING LEGACIES WITH AN ENGRAVED BRICK FUNDRAISER</p>
                    <div class="learn-more">
                        <router-link to="/proven-benefits" tag="button" class="learn-more-button">
                            <span>LEARN MORE</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="home-ourway">
            <div class="row">
                <div class="col-xs-12 ourway-motto">
                    <strong class="strong-quote">The Fund Raisers, Ltd. Advantage</strong>
                </div>
            </div>
            <div class="row home-stats">
                <div class="col-sm-12 col-xs-12 col-md-4 home-engraving text-center">
                    <div class="stats-content">
                        <h2>32+</h2>
                        <p>YEARS OF EXPERIENCE</p>
                    </div>
                </div>
                <div class="col-sm-12 col-xs-12 col-md-4 home-website text-center">
                    <div class="stats-content">
                        <h2>2,000+</h2>
                        <p>ENGRAVED BRICK PROJECTS</p>
                    </div>
                </div>
                <div class="col-sm-12 col-xs-12 col-md-4 home-roadmap text-center">
                    <div class="stats-content">
                        <h2>750K+</h2>
                        <p>BRICKS ENGRAVED</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row home-icons">
            <router-link to="/unmatched-quality" tag="div" class="col-sm-12 col-xs-12 col-md-6">
                <div class="icon-content home-quality">
                    <div class="flex-container">
                        <div class="rounded-content text-center">
                                <p class="heading">UNMATCHED QUALITY</p>
                            <p>Hand-Crafted for Lasting Impact!</p>
                        </div>
                    </div>
                </div>
            </router-link>
            <router-link to="/fundraising-toolkit" tag="div" class="col-sm-12 col-xs-12 col-md-6">
                <div class="icon-content home-toolkit">
                    <div class="flex-container">
                        <div class="rounded-content text-center">
                            <p class="heading">FUNDRAISING TOOLKIT</p>
                            <p>All the Tools for Your Success!</p>
                        </div>
                    </div>
                    <img class="orange-callout" src="images/Home-Page/homeorangecallout.png" alt="Free Brick Fundraiser Website">
                </div>
            </router-link>
        </div>

        <div class="box-content home">
            <div class="box-content-inner">

                <div class="home-products">
                    <div class="home-products-left">
                        <img width="450" height="371" class="img-responsive" src="images/Home-Page/homeproducts.png" alt="Products">
                    </div>
                    <div class="home-products-right">
                        <div class="row">
                            <div class="col-xs-12 text-center products">
                                No Upfront Costs
                            </div>
                        </div>

                        <div class="row products-list">
                            <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                                <div class="icon-box">
                                    <img class="" src="images/checkbox.png" alt="">
                                </div>
                                <p class="heading">No Minimum Order</p>
                            </div>
                            <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                                <div class="icon-box">
                                    <img class="" src="images/checkbox.png" alt="">
                                </div>
                                <p class="heading">Free Personalized<br/>Marketing Sample!</p>
                            </div>
                            <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                                <div class="icon-box">
                                    <img class="" src="images/checkbox.png" alt="">
                                </div>
                                <p class="heading">Free Shipping</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 text-center">
                                <router-link to="/product-guide" tag="button" class="learn-more-button">
                                    <span>PRODUCT GUIDE</span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <router-link to="/how-it-works" tag="div" class="home-howto">
                <div class="row">
                    <div class="col-xs-12 howto-heading">
                        How to Get Started
                    </div>
                </div>
                <div class="howto-content">
                    <div class="howto-step">
                        <div class="step-content one">
                            <p>
                                REQUEST OUR<br/>
                                FUNDRAISING TOOLKIT
                            </p>
                            <div class="step-number">
                                <div class="number-circle one">
                                    <span>1</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="howto-divider left"></div>
                    <div class="howto-divider bottom"></div>
                    <div class="howto-step">
                        <div class="step-content two">
                            <p>
                                SUBMIT YOUR<br/>
                                BRICK FUNDRAISER<br/>
                                REGISTRATION
                            </p>
                            <div class="step-number">
                                <div class="number-circle two">
                                    <span>2</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="howto-divider left"></div>
                    <div class="howto-divider bottom"></div>
                    <div class="howto-step">
                        <div class="step-content three">
                            <p>
                                LAUNCH YOUR<br/>
                                FUNDRAISER
                            </p>
                            <div class="step-number">
                                <div class="number-circle three">
                                    <span>3</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="howto-divider leftmost"></div>
                    <div class="howto-divider bottommost"></div>
                </div>
            </router-link>

            <div class="testimonials testimonials-home">
                100+ PROFESSIONAL AND COLLEGIATE SPORTS TEAMS AND FACILITIES
                <br/>AND THOUSANDS OF COMMUNITY FUNDRAISERS
            </div>
            <testimonials-carousel>
                <div class="carousel-inner quote-slider" role="listbox">
                    <div class="quote-slider-item item active">
                        <p class="slider-text">
                            “We found our personal paver program to be an extremely positive fan experience that could very possibly create a lifetime connection/loyalty to the team. The realization that future generations can visit the stadium and see a place of their family legacy creates huge personal ties to these programs.”
                        </p>
                        <div class="quote-author">
                            <span>Jay Souers, Vice President of Sponsorship Sales</span>
                            <span>Indianapolis Colts</span>
                            <span>Phase I: 2009 | Phase II: 2014</span>
                        </div>
                    </div>
                    <div class="quote-slider-item item">
                        <p class="slider-text">
                            “Our partnership with Fund Raisers, Ltd. has been very positive. I would encourage any company that is looking to raise revenue for a project to partner with Fund Raisers, Ltd. on a tile or brick program. Their professionalism and service made the entire project very simple, smooth and profitable.”
                        </p>
                        <div class="quote-author">
                            <span>Danny Dann, Director, Sponsorship Services</span>
                            <span>San Francisco Giants</span>
                            <span>Phase I: 2000 | Phase II: 2002 | Phase III: 2008 | Phase IV: 2011</span>
                        </div>
                    </div>
                    <div class="quote-slider-item item">
                        <p class="slider-text">
                            “This project has far exceeded our expectations in terms of creating a tangible display of the emotional connection between our fans and the White Sox team and organization. Aethetically and finacially the project was a success. In large part our success is attributed to Fund Raisers, Ltd. We know we selected the best partner in working with them.”
                        </p>
                        <div class="quote-author">
                            <span>Christine O'Reilly, Senior Director of Community Relations</span>
                            <span>Chicago White Sox</span>
                            <span>Phase I: 2008 | Phase II: 2009 | Phase III: 2015</span>
                        </div>
                    </div>
                </div>
            </testimonials-carousel>

        </div>
    </div>
</template>

<script type="text/jsx">
    import Testimonials from "./projects/Testimonials";
    export default {
        name: 'home',
        components: {
            'testimonials-carousel': Testimonials
        },
        metaInfo: {
            title: 'Fund Raisers, Ltd. Successful fundraising & community engagement',
            titleTemplate: null,
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Successful fundraising, community engagement, uniting communities brick-by-brick'
                }
            ]
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Home.vue?422420c3